<template>
	<div id="app">
		<div id="Eva" v-if="(state === 'live') | (state === 'demo')">
			<div class="EvaTitel">
				<div class="Kaestchen">
					<img class="Kaestchen-Diff" src="@/assets/img/diff_logo.png" />
					<div class="Kaestchen-Text">
						<b>
							<u>{{ evaHead.title[lang] }}</u>
						</b>
					</div>
					<img class="Kaestchen-Logo" @click="updateQuest" src="@/assets/img/qualis_logo.png" />
				</div>
				<div class="infos">
					<select v-if="urlObject.demo" id="bogen" v-model="type" @change="handleChange" style="float: right">
						<option v-for="t in types" :key="t" v-bind="{ value: t }">
							{{ t }}
						</option>
					</select>
					<p>
						<b>
							<u>{{ evaHead.courseInfo[lang] }}</u>
						</b>
					</p>
					<p>{{ evaHead.courseTitle[lang] }}: {{ Veranstaltung.titel }}</p>
					<p>{{ evaHead.courseLecturer[lang] }}: {{ Veranstaltung.dozent }}</p>
					<p class="abstand-oben">
						<b>
							<u>{{ evaHead.evaStart[lang] }}</u>
						</b>
					</p>
					<!-- <p>
            <small v-if="type !== 'doz' && type !== 'fakP'">{{ generalMsg[lang] }}</small>
          </p> -->
				</div>
			</div>
			<QUE @state:end="state = 'end'" :quest="quest" :Participant="Participant" :Veranstaltung="Veranstaltung" :state="state" />
		</div>
		<div id="Loading" v-if="state === 'load'">
			<loading />
		</div>
		<gMSG v-if="state === 'msg'" :msg="currentMSG" />
		<end v-if="state === 'end'" />
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import templates from "@/assets/js/templates.js";
import templates_en from "@/assets/js/templates_en.js";
import COMM from "@/assets/js/communication.js";
import MSG from "@/assets/js/messages.js";
import QUE from "@/components/questionnaire.vue";
import loading from "@/components/messages/loading.vue";
import end from "@/components/messages/end.vue";
import gMSG from "@/components/messages/generalMessage.vue";
templates.en = templates_en;

export default {
	name: "App",
	components: {
		QUE,
		loading,
		end,
		gMSG,
	},
	data() {
		return {
			types: Object.getOwnPropertyNames(templates.de),
			type: "bsp",
			quest: undefined,
			state: "live",
			Veranstaltung: {
				titel: "Testveranstaltung",
				dozent: "Prof. Dr. Sarah Dozent",
				dsp: ["Doz A", "Doz B"],
				lang: "de",
			},
			Participant: {
				lsf: "",
				response: [],
			},
			urlObject: {},
			currentMSG: {},
		};
	},
	methods: {
		...mapActions(["setLang"]),
		async handleChange() {
			this.quest = await templates[this.Veranstaltung.lang][this.type]();
		},
		async updateQuest() {
			let postResponse = await COMM.getQuest(this.urlObject.lsf, this.urlObject.pw);
			if (postResponse.live === "false") {
				this.state = "msg";
				this.currentMSG = MSG.notLive[this.Veranstaltung.lang];
			} else if (postResponse.Bogen) {
				this.type = postResponse.Bogen;
				this.Veranstaltung.titel = postResponse.Titel;
				this.Veranstaltung.dozent = postResponse.Dozent;
				this.Veranstaltung.dsp = postResponse.dsp.split(",");
				this.Veranstaltung.lang = postResponse.lang;
				if (this.Veranstaltung.lang === "en" && !(templates[this.Veranstaltung.lang.trim()][this.type.trim()] instanceof Function)) {
					const template = await templates["de"][this.type.trim()]();
					console.log(template);
					this.quest = await templates["de"][this.type.trim()]();
				} else {
					const template = await templates[this.Veranstaltung.lang.trim()][this.type.trim()]();
					console.log(template);
					this.quest = await templates[this.Veranstaltung.lang.trim()][this.type.trim()]();
				}
				this.state = "live";
			} else if (postResponse.trim() === "No rows") {
				this.state = "msg";
				this.currentMSG = MSG.notFound[this.Veranstaltung.lang];
			}
		},
	},
	computed: {
		...mapGetters(["generalMsg", "lang", "evaHead"]),
	},
	async beforeMount() {
		this.urlObject = COMM.getURL();
		this.Participant.lsf = this.urlObject.lsf;
		if (this.urlObject.demo == false) {
			await this.updateQuest();
		} else {
			this.state = "demo";
			this.quest = await templates.de.bsp();
		}
		let lastBlock = this.quest[this.quest.length - 1];
		let questLen = lastBlock.items[lastBlock.items.length - 1].id;
		if (lastBlock.type === "dsp") questLen += lastBlock.items.length * (this.Veranstaltung.dsp.length - 1);
		this.Participant.response = Array(questLen).fill("99");
		this.setLang(this.Veranstaltung.lang);
	},
};
</script>

<style>
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
	margin: 0;
	padding: 0;
	border: 0;
	outline: 0;
	font-weight: inherit;
	font-style: inherit;
	font-size: 100%;
	font-family: inherit;
	vertical-align: baseline;
}
/* remember to define focus styles! */
:focus {
	outline: 0;
}
body {
	line-height: 1;
	color: black;
	background: white;
}
ol,
ul {
	list-style: none;
}
/* tables still need 'cellspacing="0"' in the markup */
table {
	border-collapse: separate;
	border-spacing: 0;
}
caption,
th,
td {
	text-align: left;
	font-weight: normal;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
	content: "";
}
blockquote,
q {
	quotes: "" "";
}
/* Ab hier eigentliches CSS */
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	font-size: 100%;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	padding: 0 1%;
	max-width: 75vw;
	margin: 0 auto;
}
@media screen and (max-width: 480px) {
	#app {
		max-width: 100vw;
	}
}

#app > * {
	margin-top: 1vh;
	margin-bottom: 1vh;
}

.EvaTitel b,
u {
	font-size: 1rem;
}

.EvaTitel small {
	font-size: 0.8rem;
}

.Kaestchen {
	background-color: #aaaaaa;
	width: 100%;
	height: calc(98% / 12.5);
	margin-bottom: 3vmax;
	border: 1px black solid;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 100%;
	grid-template-areas: "diff txt logo";
}

.Kaestchen-Text {
	text-align: center;
	grid-area: txt;
	align-self: center;
}

.Kaestchen-Logo {
	grid-area: logo;
	align-self: center;
	justify-self: end;
	display: block;
	height: calc(98vw / 12.5 * 0.95);
}
.Kaestchen-Diff {
	grid-area: diff;
	align-self: center;
	justify-self: start;
	display: block;
	height: calc(98vw / 12.5 * 0.95);
}
.infos p {
	margin: 1%;
}
.infos .abstand-oben {
	margin-top: 2vw;
}
</style>
